import { getUTCOffsetHours } from "Utils/dateHelpers";

export const questionColConfig = {
  smOffset: 1,
  sm: 10,
  mdOffset: 2,
  md: 8,
  lgOffset: 3,
  lg: 6,
};

export const headerColConfig = {
  mdOffset: 1,
  md: 10,
};

const toDate = (value) => {
  if (value instanceof Date) {
    return new Date(value.getTime()); // clone
  }
  if (typeof value === "string") {
    const parsed = new Date(value);
    if (!isNaN(parsed.getTime())) {
      return parsed;
    }
  }
  throw new Error("Invalid date value provided");
};

const cloneDate = (date) => {
  return new Date(date.getTime());
};
const addHours = (date, hours) => {
  const d = toDate(date);
  d.setHours(d.getHours() + hours);
  return d;
};
const addMonths = (date, months) => {
  const d = toDate(date);
  const day = d.getDate();
  d.setMonth(d.getMonth() + months);
  // Handle month overflow
  if (d.getDate() < day) {
    d.setDate(0); // last day of previous month
  }
  return d;
};
const addYears = (date, years) => {
  const d = toDate(date);
  d.setFullYear(d.getFullYear() + years);
  return d;
};
const subtractDays = (date, days) => {
  const d = toDate(date);
  d.setDate(d.getDate() - days);
  return d;
};
const endOfDay = (date) => {
  const d = toDate(date);
  d.setHours(23, 59, 59, 999);
  return d;
};

function lbmmHireDates(employeeHiredAt, largeGroup) {
  const hiredAt = addHours(employeeHiredAt, getUTCOffsetHours());
  const { adminDuration, measurementDuration, stabilityDuration } = largeGroup;
  const measurementPeriodStartDate = hiredAt;
  const adminPeriodStartDate = addMonths(measurementPeriodStartDate, measurementDuration);
  const measurementPeriodEndDate = addYears(endOfDay(subtractDays(measurementPeriodStartDate, 1)), 1);
  const stabilityPeriodStartDate = addMonths(adminPeriodStartDate, adminDuration);
  const adminPeriodEndDate = endOfDay(subtractDays(stabilityPeriodStartDate, 1));
  const stabilityPeriodEndDate = endOfDay(subtractDays(addMonths(stabilityPeriodStartDate, stabilityDuration), 1));
  endOfDay(subtractDays(addMonths(stabilityPeriodStartDate, stabilityDuration), 1));

  return {
    hiredAt,
    stabilityPeriodStartDate,
    stabilityPeriodEndDate,
    measurementPeriodStartDate,
    measurementPeriodEndDate,
    adminPeriodStartDate,
    adminPeriodEndDate,
  };
}

export const employeeAcaStatus = (employeeForm, largeGroup) => {
  const hiredAt = employeeForm.hiredAt || employeeForm.hired_at;
  const employeeType = employeeForm.employeeType || employeeForm.employee_type;
  const workStatus = employeeForm.workStatus || employeeForm.work_status;
  const partTimeEligibleAt = employeeForm.partTimeEligibleAt || employeeForm.part_time_eligible_at;

  if (largeGroup?.acaReporting) {
    switch (employeeType) {
      case "owner":
        return "Owner";
      case "1099":
        return "Contractor";
      case "full_time":
        if (workStatus === "full_time") {
          return "Full-Time";
        }
        if (workStatus === "part_time") {
          const { measurementPeriodEndDate, adminPeriodStartDate, adminPeriodEndDate } = lbmmHireDates(hiredAt, largeGroup);
          const today = new Date();
          if (partTimeEligibleAt) {
            return "Part-Time Eligible";
          }
          if (largeGroup.measurementMethod === "monthly") {
            if (addMonths(hiredAt, 1) >= today) {
              return "Part-Time, In Measurement Period";
            }
            return "Part-Time, Ineligible";
          }
          if (largeGroup.measurementMethod === "lookback") {
            if (measurementPeriodEndDate >= today) {
              return "Part-Time, In Measurement Period";
            }
            if (adminPeriodStartDate < today && adminPeriodEndDate >= today) {
              return "Part-Time, In Administration Period";
            }
            return "Part-Time, Ineligible";
          }
        }
    }
  }
};
